import { render, staticRenderFns } from "./ProductMonitor.vue?vue&type=template&id=719905f8&scoped=true&"
import script from "./ProductMonitor.vue?vue&type=script&lang=js&"
export * from "./ProductMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ProductMonitor.vue?vue&type=style&index=0&id=719905f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719905f8",
  null
  
)

export default component.exports